import React from 'react'

import FileAttachment from 'common/FileAttachment'
import FormControlled from 'common/Forms/Base/FormControlled'

export default props => <FormControlled tag={FileAttachment} {...props} />
